import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section id="about" className="relative pt-24 pb-20 lg:pt-32 lg:pb-32 overflow-hidden" style={{
    backgroundColor: '#0D121D',
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rE1238hztfN1VC4TBH5ZzX/Website_Background-01.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }} data-id="element-49">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-50">
        <div className="mb-8 flex justify-center" data-id="element-51">
          <img src="https://cdn.magicpatterns.com/uploads/nLctKqm9PvqkEeqbNJKN4Y/Twice_Bourne_Brand_Logo-07.png" alt="Twice Bourne Logo" className="max-w-lg w-full h-auto" data-id="element-52" />
        </div>

        <p className="mt-4 max-w-2xl mx-auto text-slate-300 mb-10" style={{
        fontSize: '1.25rem'
      }} data-id="element-53">
          Twice Bourne is a premier holding company dedicated to delivering
          exceptional quality and innovation through our diverse portfolio of
          specialized brands.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-54">
          <a href="#brands" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-slate-900 bg-white hover:bg-slate-100 transition-colors duration-200 w-full sm:w-auto" data-id="element-55">
            Explore Our Brands
            <ArrowRight className="ml-2 h-5 w-5" aria-hidden="true" data-id="element-56" />
          </a>
          <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-white border border-slate-700 hover:bg-slate-800 transition-colors duration-200 w-full sm:w-auto" data-id="element-57">
            Contact Us
          </a>
        </div>
      </div>
    </section>;
}